/**
 * The one text-to-code rule (SA-1031 spec §5.1), twin of backend
 * `app.services.airports.station_code`, pinned by shared/station-code-cases.json:
 * exactly three letters → the code upper-cased; else exactly one `(XXX)`
 * parenthetical → XXX; else nothing. A four-letter ICAO in a text slot stays
 * text: the quote flow speaks IATA.
 *
 * `isStationShape` is the one station shape (SA-1053), twin of
 * `airport_codes.is_station_shape`, pinned by shared/station-shape-cases.json:
 * three ASCII letters once trimmed, any case; never upper-case first.
 */
const BARE = /^[A-Za-z]{3}$/
const PAREN = /\(([A-Za-z]{3})\)/g

export function stationCode(text: string | null | undefined): string | null {
  if (!text) return null
  const stripped = text.trim()
  if (BARE.test(stripped)) return stripped.toUpperCase()
  const found = Array.from(stripped.matchAll(PAREN))
  return found.length === 1 ? found[0][1].toUpperCase() : null
}

export function isStationShape(text: string | null | undefined): boolean {
  return typeof text === 'string' && BARE.test(text.trim())
}
